import React, { Component, Fragment } from "react";
import SearchBoxHolder from "./Styles/searchBoxStyle";
import { Menu, Dropdown, Button, Col, Icon, Input, Row, Select, message, Radio, Form, Tooltip, Checkbox, Modal, Switch } from "antd";
import { withRouter } from "react-router";
import PlacesAutocomplete, {
  geocodeByAddress
} from "react-places-autocomplete";
import "react-dates/initialize";
import { DateRangePicker } from "react-dates";
import {
  VERTICAL_ORIENTATION,
  HORIZONTAL_ORIENTATION
} from "react-dates/constants";
import "react-dates/lib/css/_datepicker.css";
import moment from "moment";
import {
  convertBounds,
  updateParams,
  getDatesRange
} from "../services/display";
import queryString from "query-string";
import OnboardingContainer from "../containers/OnboardingContainer";
import { Trans, withTranslation } from 'react-i18next';
import UserRoleEnum from '../constants/UserRoleEnum';
import { hasAccessRole, SeparateNumberFormat } from "../services/utils"
import { CSSTransition } from 'react-transition-group';
import CSSEffect from './Styles/CSSEffect'
import { getMinimunByCurrency } from "../services/utils";
import VerifiedAgencyInfoModal from './VerifiedAgencyInfoModal';
import { getDomain } from "../services/utils";
import HelpTooltipIcon, { HelpIcon } from "./customComponents/HelpIcon/HelpTooltipIcon";
import CampaignFormModal from './CampaignFormModal';
import Colors from "../themes/Colors";
import logoAI from "../images/ICONO-ESTRELLAS-IA.png";
import styled from "styled-components";

const BriefModalWrapper = styled.div`
  background: #303030;
  border-radius: 10px;
  overflow: hidden;
`;

const BriefModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
`;

const BriefModalTitle = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${Colors.primaryAccent};
  font-weight: 600;
  font-size: 20px;
`;

const BriefModalClose = styled.span`
  display: flex;
  align-items: center;
  color: rgba(255, 255, 255, 0.55);
  font-size: 13px;
  cursor: pointer;
  transition: color 0.2s;
  &:hover { color: rgba(255, 255, 255, 0.9); }
`;

const BriefModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 4px 16px 16px;
`;

const BriefModalCard = styled.div`
  background: ${Colors.snow};
  border-radius: 8px;
  border: 1px solid ${Colors.border};
  padding: 10px 12px;
`;

const BriefModalCardLabel = styled.div`
  font-weight: 700;
  margin-bottom: 6px;
  color: ${Colors.textStrong};
  font-size: 13px;
`;

const BriefModalCardContent = styled.div`
  color: ${Colors.textSecondary};
  font-size: 13px;
  line-height: 1.5;
  max-height: 25vh;
  overflow-y: auto;
`;

const BriefModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 6px;
`;

const BriefModalBackBtn = styled(Button)`
  && {
    background: #2d2e4a;
    border: none;
    color: ${Colors.white};
    border-radius: 20px;
    min-width: 90px;
    font-weight: 500;
    &:hover, &:focus {
      background: #3d3f5a;
      color: ${Colors.white};
    }
  }
`;

const BriefModalConfirmBtn = styled(Button)`
  && {
    border-radius: 20px;
    min-width: 180px;
    font-weight: 500;
  }
`;

const { Option } = Select;

const { TextArea } = Input;

const domain = getDomain(window.location.hostname);
class SearchBoxContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      address: "",
      acceptedGuaranteedTerms: false,
      redirect: false,
      addressResult: "",
      isVerifiedAgencyModalVisible: false,
      verifiedAgencyError: null,
      isMediaCompanyInfoModalVisible: false,
      type: 'classic',
      brief: '',
      url: '',
      createdPlannerData: null,
      didMount: false,
      optimizeBriefModalVisible: false
    };
  }

  handleCreatePlanner = async (plannerData, skip) => {
    this.props.toggleCampaignFormModal(true)
    this.props.getCampaignCategoriesRequest();
    this.props.getCampaignPOIRequest();
    this.props.getCampaignScreensRequest();
    this.props.createPlannerRequest({ plannerData, skip });
  };


  componentDidMount() {
    if (this.props.user && this.props.user.roles.find(element => element === 'agency-member') === 'agency-member' || this.props.user && this.props.user.roles.find(element => element === 'company-member') === 'company-member') {
      this.props.clearCampaignData({ actionBy: "searchBox" });
      this.props.getClients(this.props.user.id);
      if (this.props.user.company && this.props.user.company.enable_external_dsp_selector) {
        this.props.getExternalDsps();
      }
    } else {
      this.props.history.replace("/");
    }
    navigator.geolocation.getCurrentPosition(
      (position) => {
        // this.setState({position});
        if (position && position.coords.longitude && position.coords.latitude) {
          // this.props.setCoords(position.coords)
          this.setState({
            lat_ne: position.coords.latitude + 0.5,
            lat_sw: position.coords.latitude - 0.5,
            lng_ne: position.coords.longitude + 0.5,
            lng_sw: position.coords.longitude - 0.5,
          });
        }
      });
    if (domain === 'dv360') {
      this.props.setProgrammatic('programmatic');
      if (this.props.dsps && this.props.dsps.length > 0) {
        const dv360Dsp = this.props.dsps.find(d =>
          d.id && d.id === 75
        );
        this.props.setDsp(dv360Dsp);
      }
    } else {
      this.props.setProgrammatic('programmatic');
    }
    this.props.getConversionRates();
    this.setState({ didMount: true });
  }
  componentDidUpdate(nextProps) {
    const { user, dsps, conversionRates, getConversionRates, optimizedBrief } = this.props;
    if (user != nextProps.user && (!dsps || (dsps && dsps.length === 0))) {
      this.props.getExternalDsps();
    }

    if (!this.validateDates({ startDate: this.state.startDate, endDate: this.state.endDate })) {
      this.setState({ startDate: null, endDate: null })
    };
    if (!conversionRates) {
      getConversionRates();
    }

    if (optimizedBrief && optimizedBrief !== nextProps.optimizedBrief) {
      this.setState({ optimizeBriefModalVisible: true });
    }
  }

  renderIdentificationClients = () => {
    return this.props.clients.map(client => {
      return (
        <Select.Option key={client.id} value={client.id}>
          {client.name}
        </Select.Option>
      );
    });
  };

  renderIdentificationBrands = () => {
    return this.props.brands.map(brand => {
      return (
        <Select.Option key={brand.id} value={brand.id}>
          {brand.name}
        </Select.Option>
      );
    });
  };

  renderIdentificationDsp = () => {
    const { dsps, isGuaranteed } = this.props;
    let listDsp = [...dsps];
    const isDv360 = domain === 'dv360';

    if(isDv360) {
      listDsp = listDsp.filter(
        item => item.id && item.id === 75
      );
    }

    if (isGuaranteed) {
      listDsp = listDsp.filter(
        item => item.allow_guaranteed
      );
    }
    if (!isDv360) {
      listDsp.unshift({ id: null, name: 'Latinad', exchange: 'Latinad' });
    }

    const renderExchange = !isDv360

    return listDsp.map(dsps => {
      return (
        <Select.Option default={dsps.id == null} key={dsps.id} value={dsps.id}>
          {dsps.name} {renderExchange && <span style={{ color: "rgb(135 135 135)" }}>{dsps.exchange}</span>}
        </Select.Option>
      );
    });
  };

  handleChange = address => {
    this.setState({ address });
  };

  changeUrl = (url) => {
    if (!url) return url;
    if (url.startsWith('www.') || !url.includes('://')) {
      url = 'https://' + url;
    }
    url = url.replace(/^(http|ftp):\/\//i, 'https://');
    this.setState({ url });
    return url;
  };

  handleSelect = address => {
    this.setState({ address });
    return geocodeByAddress(address)
      .then(results => {
        this.setState({ bounds: convertBounds(results[0].geometry.viewport) });
        const coords = convertBounds(results[0].geometry.viewport)
        this.props.setCoords(coords)
        if (results) {
          if (results[0].types[0] === 'continent') {
            this.props.setMapZoom(2)
          } else if (results[0].types[0] === 'country') {
            this.props.setMapZoom(5)
          } else if (results[0].types[0] === 'administrative_area_level_1') {
            this.props.setMapZoom(7)
          } else if (results[0].types[0] === 'administrative_area_level_2') {
            this.props.setMapZoom(9)
          } else if (results[0].types[0] === 'colloquial_area') {
            this.props.setMapZoom(11)
          } else if (results[0].types[0] === 'locality') {
            this.props.setMapZoom(12)
          } else if (results[0].types[0] === 'political' || (results[0].lenght > 1 && results[0].types[1] === 'sublocality')) {
            this.props.setMapZoom(14)
          } else if (results[0].types[0] === 'intersection' || results[0].types[0] === 'street_address' || results[0].types[0] === 'street_number' || results[0].types[0] === 'route') {
            this.props.setMapZoom(18)
          } else if (results[0].types[0] === 'establishment' || results[0].types[0] === 'point_of_interest' || results[0].types[0] === 'shopping_mall') {
            this.props.setMapZoom(16)
          }
        }
        this.setState({ addressResult: results[0].address_components })

        if (!this.props.user) return;

        const getAudienceData = {
          "_method": "GET",
          "start_date": this.state.startDate ? moment(this.state.startDate._d).format("YYYY-MM-DD") : moment().subtract(30, 'days').format("YYYY-MM-DD"),
          "end_date": this.state.endDate ? moment(this.state.startDate._d).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
          "address_components": results[0].address_components
        }
        this.props.getAudience(getAudienceData);
      })
      .catch(error => console.error("Error", error));
  };

  changeClient = (clientSelect) => {
    const client = this.props.clients.find(client => client.id === clientSelect.key);
    this.props.setClient(client)
    this.props.setBrands(client.brands);
  }

  changeBrand = (brandSelect) => {
    this.props.setBrand(this.props.brands.find(brand => brand.id === brandSelect.key))
  }

  changeDsp = (dspSelect) => {
    this.props.setDsp(this.props.dsps.find(dsp => dsp.id === dspSelect.key))
  }

  changeProgrammaticMode = e => {
    const { isSuperUser, dsp, dsps } = this.props;
    const value = e.target.value;

    if (value === 'traditional') {
      this.props.setProgrammatic('traditional');
      this.props.setIsGuaranteed(false);
      this.props.setDsp(null);
    }
    else if (value === 'programmatic_pmp') {
      this.props.setProgrammatic('programmatic');
      this.props.setIsGuaranteed(false);
      if (domain === 'dv360') {
        if (dsps && dsps.length > 0) {
          const dv360Dsp = dsps.find(d =>
            d.exchange &&
            d.exchange.toLowerCase() === 'magnite' &&
            d.name.includes('DV360')
          );
          this.props.setDsp(dv360Dsp);
        }
      }else {
        this.props.setDsp(null);
      }
    }
    else if (value === 'programmatic_pg') {
      this.props.setProgrammatic('programmatic');
      this.props.setIsGuaranteed(true);
      const guaranteedDsps = dsps ? dsps.filter(d => d.allow_guaranteed) : [];
      if (guaranteedDsps.length > 0) {
        const dv360Dsp = guaranteedDsps.find(d => d.name.includes('DV360'));
        this.props.setDsp(dv360Dsp || guaranteedDsps[0]);
      }
      const currentIsAllowedGuaranteed = dsp && dsp.allow_guaranteed;
      if (!currentIsAllowedGuaranteed && guaranteedDsps.length === 0) {
        message.info(this.props.t("For guaranteed campaigns, only Magnite DSPs are permitted."));
      }
    }
    this.props.handleBudgetBanner();
  };

  changeTypeMode = e => {
    const newType = e.target.value;
    const { user, triggerLogin, history } = this.props;
    if (newType === 'aiPlanner' && !user) {
      if (triggerLogin) {
        triggerLogin();
      } else {
        history.push("/login");
      }
      return;
    }
    this.setState({ type: newType });
    if (newType === 'aiPlanner') {
      this.props.setProgrammatic('programmatic')
      this.props.setIsGuaranteed(false)
      this.props.setAcceptedGuaranteedTerms(false)
    } else {
      this.props.setProgrammatic('programmatic')
      this.props.setIsGuaranteed(false)
    }
  };

  // Limit programmatic campaign to 5000USD budget for non verified agencies
  validateBudget = (budget) => {
    const { user, programmatic, currency, conversionRates, t } = this.props;
    const isUnverifiedAgency = user && user.company && user.company.type === 'agency' && !user.company.is_verified;
    const conversionRate = conversionRates.find(rate => rate.currency === currency);
    const maxBudget = 5000 * conversionRate.rate;
    const overBudget = budget > maxBudget;
    const isSuperUser = user && user.roles && (user.roles.includes(UserRoleEnum.superAdmin) || user.roles.includes(UserRoleEnum.superModeratorAgency));
    if (isUnverifiedAgency && programmatic === 'programmatic' && overBudget && !isSuperUser) {
      this.setState({ verifiedAgencyError: t('The maximum budget for non verified agencies is 5000 USD a month') });
      this.showVerifiedAgencyModal();
      return Math.floor(maxBudget);
    }
    return budget;
  }

  handleAmountChange(e) {
    let rawValue = e.target.value;
    rawValue = rawValue.replace(/[^0-9.]/g, '');
    const parts = rawValue.split('.');
    if (parts.length > 2) {
      rawValue = parts[0] + '.' + parts.slice(1).join('');
    }
    if (rawValue.includes('.')) {
      const decimalPart = rawValue.split('.')[1];
      if (decimalPart && decimalPart.length > 2) {
        rawValue = parts[0] + '.' + decimalPart.slice(0, 2);
      }
    }
    let numericValue = rawValue === '' ? null : Number(rawValue);
    const MAX_VALUE = 999999999999.99;
    if (numericValue !== null) {
      numericValue = Math.floor(numericValue * 100) / 100;
      if (numericValue > MAX_VALUE) {
        numericValue = MAX_VALUE;
      }
    }
    const validatedBudget = this.validateBudget(numericValue);
    this.props.setBudget(validatedBudget);
    e.target.value = rawValue;
  }

  // Limit traditional campaigns to a week for non verified agencies
  validateDates = (dates) => {
    const { user, programmatic, t } = this.props;
    const isUnverifiedAgency = user && user.company && user.company.type === 'agency' && !user.company.is_verified;
    const datesAreValid = dates.startDate && dates.endDate;
    const isSuperUser = user && user.roles && (user.roles.includes(UserRoleEnum.superAdmin) || user.roles.includes(UserRoleEnum.superModeratorAgency));
    if (isUnverifiedAgency && datesAreValid && programmatic === 'traditional' && !isSuperUser) {
      const diff = dates.endDate.diff(dates.startDate, 'days');
      if (diff > 7) {
        this.setState({ verifiedAgencyError: t("The maximun duration of a traditional campaign for non-verfied agencies is limited to a week.") });
        this.showVerifiedAgencyModal();
        return false;
      }
    }
    return true;
  }

  setDates = (dates) => {
    if (!this.validateDates(dates)) return;

    this.setState({ startDate: dates.startDate, endDate: dates.endDate })

    if (!this.props.user) return;

    if (dates.startDate && dates.endDate) {
      const getAudienceData = {
        "_method": "GET",
        "start_date": dates.startDate._d ? moment(dates.startDate._d).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
        "end_date": dates.endDate._d ? moment(dates.endDate._d).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
        "address_components": this.state.addressResult
      }
      this.props.getAudience(getAudienceData);
    }
  }

  showVerifiedAgencyModal = () => {
    this.setState({ isVerifiedAgencyModalVisible: true });
  };

  hideVerifiedAgencyModal = () => {
    this.setState({ isVerifiedAgencyModalVisible: false });
  };

  isUnverifiedMediaCompany = () => {
    const { user } = this.props;
    return user && user.company && user.company.type === 'media' && !user.company.is_verified;
  };

  render() {
    const { t, i18n, showBudget, user, dsp, isSuperUser, programmatic, isGuaranteed } = this.props;
    moment.locale(i18n.language);

    const isProgrammaticProviders = this.props.user && this.props.user.holding && this.props.user.holding.id === 50;

    let isAgency = false;
    if (this.props.user && (hasAccessRole(this.props.user.roles, [UserRoleEnum.agencyMember, UserRoleEnum.companyMember]))) {
      isAgency = true;
    }

    const isMediaOwner = !!(
      user &&
      user.roles &&
      (hasAccessRole(user.roles, [UserRoleEnum.companyMember]) || user.is_in_media_holding)
    );

    const programmaticValue = programmatic === 'traditional'
      ? 'traditional'
      : (isGuaranteed ? 'programmatic_pg' : 'programmatic_pmp');

    return (
      <SearchBoxHolder domain={domain}>
        <Row type="flex" justify="center" align="middle">
          <Col xs={23} sm={22} md={22} lg={22} xl={22} className="searchBox">

            <Row gutter={16}>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                style={{ zIndex: "0" }}
              >
                <Radio.Group
                  value={this.state.type}
                  onChange={this.changeTypeMode}
                  className="typePurchaseRadioButton"
                >
                  <Radio.Button
                    size="large"
                    className={
                      domain === "hakMedia"
                        ? "solidColorButton typePurchaseRadioButtonTraditional"
                        : "typePurchaseRadioButtonTraditional"
                    }
                    value="classic"
                    disabled={isProgrammaticProviders}
                  >
                    {t("Classic version")}
                  </Radio.Button>
                  <Radio.Button
                    size="large"
                    className={
                      domain === "hakMedia"
                        ? "solidColorButton typePurchaseRadioButtonProgrammatic"
                        : "typePurchaseRadioButtonProgrammatic"
                    }
                    value="aiPlanner"
                    disabled={isProgrammaticProviders}
                  >
                    {t("AI Planner")}
                    <img
                      src={logoAI}
                      style={{ maxHeight: "30px" }}
                      alt=""
                    />
                  </Radio.Button>
                </Radio.Group>
              </Col>
            </Row>

            <Col
              xs={24}
              sm={24}
              md={8}
              lg={8}
              xl={8}
              className="zonePicker"
              hidden={this.state.type === "aiPlanner"}
            >
              <div className="zoneTitle">{t("Campaign location")}</div>
              <PlacesAutocomplete
                value={this.state.address}
                onChange={this.handleChange}
                onSelect={this.handleSelect}
                searchOptions={{
                  componentRestrictions: {
                    // Google allows to put only 5 countries in this array
                    // country: ['ar', 'mx', 'es', 'gt', 'hn', 'ni', 'sv', 'bz', 'pa', 'cr', 'do']
                  },
                }}
              >
                {({
                  getInputProps,
                  suggestions,
                  getSuggestionItemProps,
                  loading,
                }) => (
                  <div>
                    <Dropdown
                      visible={this.state.address !== ""}
                      trigger={["click"]}
                      disabled={isProgrammaticProviders}
                      overlay={
                        <Menu>
                          {loading && (
                            <Menu.Item key={"loading"}>
                              {t("Loading")}...
                            </Menu.Item>
                          )}
                          {suggestions.map((suggestion) => {
                            return (
                              <Menu.Item
                                key={suggestion.id}
                                {...getSuggestionItemProps(suggestion, {
                                  className: suggestion.active
                                    ? "suggestion-item--active"
                                    : "suggestion-item",
                                })}
                              >
                                <span>{suggestion.description}</span>
                              </Menu.Item>
                            );
                          })}
                        </Menu>
                      }
                    >
                      <Input
                        addonBefore={
                          <div>
                            <Icon type="environment" />
                          </div>
                        }
                        size="large"
                        placeholder="large size"
                        data-testid="location-search-input"
                        {...getInputProps({
                          placeholder: t("Add Country or City?"),
                          className: "location-search-input",
                        })}
                      />
                    </Dropdown>
                  </div>
                )}
              </PlacesAutocomplete>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={16}
              lg={16}
              xl={16}
              className="datePicker"
              hidden={this.state.type === "aiPlanner"}
              data-testid="date-picker"
            >
              <div className="calendarIcon">
                <Icon type="calendar" />
              </div>
              <div className="dateStartTitle">{t("Campaign start")}</div>
              <div className="dateEndTitle">{t("End of campaign")}</div>
              <DateRangePicker
                startDatePlaceholderText={t("Add dates")}
                endDatePlaceholderText={t("Add dates")}
                minimumNights={0}
                startDate={
                  this.state.startDate ? moment(this.state.startDate._d) : null
                } // momentPropTypes.momentObj or null,
                startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
                endDate={
                  this.state.endDate ? moment(this.state.endDate._d) : null
                } // momentPropTypes.momentObj or null,
                endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
                onDatesChange={({ startDate, endDate }) =>
                  this.setDates({ startDate, endDate })
                } // PropTypes.func.isRequired,
                focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                onFocusChange={(focusedInput) =>
                  this.setState({ focusedInput })
                } // PropTypes.func.isRequired,
                hideKeyboardShortcutsPanel={true}
                customArrowIcon={<div />}
                orientation={
                  window.matchMedia("(max-width: 600px)").matches
                    ? VERTICAL_ORIENTATION
                    : HORIZONTAL_ORIENTATION
                }
                numberOfMonths={
                  window.matchMedia("(max-width: 600px)").matches ? 1 : 2
                }
                disabled={isProgrammaticProviders}
              />
            </Col>
            <Row>
              {isAgency ? (
                <Fragment>
                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="brief"
                    hidden={this.state.type === "classic"}
                  >
                    <div style={{ width: "100%", position: "relative" }}>
                      <TextArea
                        value={this.state.brief}
                        onChange={(e) =>
                          this.setState({ brief: e.target.value })
                        }
                        autoSize={{ minRows: 3, maxRows: 5 }}
                        placeholder={t("Campaign brief")}
                        style={{ paddingRight: "110px" }}
                      />
                      <Button
                        size="small"
                        type="primary"
                        loading={this.props.loadingOptimizeBrief}
                        onClick={() => {
                          if (!this.state.brief) {
                            return message.error(t("Enter brief to continue"), 10);
                          }
                          if (isAgency && !(this.props.client && this.props.client.id && this.props.brand && this.props.brand.id)) {
                            return message.error(t("Select a customer and brand to continue"), 10);
                          }
                          const params = {
                            brief: this.state.brief,
                            brand_id: this.props.brand && this.props.brand.id ? this.props.brand.id : undefined,
                            client_id: this.props.client && this.props.client.id ? this.props.client.id : undefined,
                            dsp_id: this.props.dsp && this.props.dsp.id ? this.props.dsp.id : undefined,
                            brand_url: this.state.url || undefined,
                          };
                          this.props.optimizeBriefRequest(params);
                        }}
                        style={{
                          position: "absolute",
                          top: "8px",
                          right: "8px",
                          borderRadius: "20px",
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          zIndex: 1,
                          marginRight: 20
                        }}
                      >
                        {!this.props.loadingOptimizeBrief && (
                          <img src={logoAI} style={{ maxHeight: "13px", opacity: 0.9 }} alt="" />
                        )}
                        {t("IA Brief")}
                      </Button>
                    </div>
                  </Col>
                  <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                    <Select
                      data-testid="client-select"
                      className="companySelect"
                      labelInValue
                      value={{
                        key:
                          this.props.client && this.props.client.id
                            ? parseInt(this.props.client.id)
                            : t("Client"),
                      }}
                      loading={this.props.loadingClients}
                      onChange={this.changeClient.bind(this)}
                      showSearch
                      filterOption={(input, option) =>
                        option.props.children &&
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      disabled={isProgrammaticProviders}
                    >
                      {this.renderIdentificationClients()}
                    </Select>
                    <div className="help-icon">
                      <HelpTooltipIcon
                        href="https://www.youtube.com/watch?v=ouAACPF6syA"
                        tooltip={
                          <Trans
                            i18nKey="To select a client, you must first create it in the “Clients” section of the CMS and then create the associated brand. Click on the <icon/> to learn how to do it."
                            components={{
                              icon: <HelpIcon />,
                            }}
                          />
                        }
                      />
                    </div>
                  </Col>
                  <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                    <Select
                      data-testid="brand-select"
                      className="brandSelect"
                      labelInValue
                      value={{
                        key:
                          this.props.brand && this.props.brand.id
                            ? parseInt(this.props.brand.id)
                            : t("Mark"),
                      }}
                      loading={this.props.loadingBrands}
                      disabled={
                        this.props.loadingBrands || isProgrammaticProviders
                      }
                      onChange={this.changeBrand.bind(this)}
                      showSearch
                      filterOption={(input, option) =>
                        option.props.children &&
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {this.renderIdentificationBrands()}
                    </Select>
                  </Col>
                </Fragment>
              ) : null}
              <Col
                xs={24}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                style={{ zIndex: "0" }}
                hidden={this.state.type === "aiPlanner"}
              >
                <Radio.Group
                  value={programmaticValue}
                  onChange={this.changeProgrammaticMode}
                  className="typePurchaseRadioButton"
                  style={{ display: 'flex' }}
                >
                  <Radio.Button
                    data-testid="programmatic_pmp-radio-button"
                    size="large"
                    className={
                      domain === "hakMedia"
                        ? "solidColorButton typePurchaseRadioButtonProgrammatic"
                        : "typePurchaseRadioButtonProgrammatic"
                    }
                    style={{ width: domain === 'dv360' ? '50%' : '33%', borderRadius: "35px 0px 0px 35px" }}
                    value="programmatic_pmp"
                    disabled={isProgrammaticProviders}
                  >
                    {t("Programmatic PMP")}
                  </Radio.Button>
                  <Radio.Button
                    data-testid="programmatic_pg-radio-button"
                    size="large"
                    className={
                      domain === "hakMedia"
                        ? "solidColorButton typePurchaseRadioButtonProgrammatic"
                        : "typePurchaseRadioButtonProgrammatic"
                    }
                    style={{ width: domain === 'dv360' ? '50%' : '33%', borderRadius: 0 }}
                    value="programmatic_pg"
                    disabled={isProgrammaticProviders}
                  >
                    {t("Programmatic PG")}
                  </Radio.Button>
                  {
                    domain !== 'dv360' && (
                      <Radio.Button
                        data-testid="traditional-radio-button"
                        checked={this.props.programmatic === "traditional"}
                        size="large"
                        className={
                          domain === "hakMedia"
                            ? "solidColorButton typePurchaseRadioButtonTraditional"
                            : "typePurchaseRadioButtonTraditional"
                        }
                        style={{ width: '33%', borderRadius: "0px 35px 35px 0px" }}
                        value="traditional"
                        disabled={isProgrammaticProviders}
                      >
                        {t("Traditional")}
                      </Radio.Button>
                    )
                  }
                </Radio.Group>
              </Col>
              {isGuaranteed && (
                <Col xs={24} style={{ marginTop: '15px', zIndex: 1 }}>
                  {/* The tint is translucent in dark mode: an opaque surface under
                      it keeps the hero images from showing through the text. */}
                  <div style={{
                    background: `linear-gradient(${Colors.extraLightPrimary}, ${Colors.extraLightPrimary}), ${Colors.snow}`,
                    padding: '15px',
                    borderRadius: '8px',
                    border: `1px solid ${Colors.lightPrimary}`,
                    marginBottom: '15px'
                  }}>
                    <h4 style={{ color: Colors.secondary, fontWeight: 'bold' }}>
                      <Icon type="info-circle" style={{ marginRight: '8px' }} />
                      {t("Guaranteed Campaign")}
                    </h4>
                    <p style={{ fontSize: '13px', marginBottom: '10px' }}>
                      {t("You guarantee the delivery of a defined number of screen appearances on specific dates and times. Inventory is reserved and the campaign takes priority to fulfill the contract, with total predictability.")}
                    </p>
                    <Checkbox
                      checked={this.props.acceptedGuaranteedTerms || this.state.acceptedGuaranteedTerms}
                      onChange={e => {
                        this.setState({ acceptedGuaranteedTerms: e.target.checked });
                        this.props.setAcceptedGuaranteedTerms(e.target.checked);
                      }}
                    >
                      <span style={{ fontSize: "12px" }}>
                        <Trans
                          i18nKey="I have read and accept the terms and conditions of the Guaranteed Campaign."
                          components={{
                            a: (
                              <a
                                href="https://cms.latinad.com/#/terms"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: Colors.primaryAccent,
                                  textDecoration: "underline",
                                  zIndex: 10,
                                  position: "relative",
                                }}
                                onClick={(e) => e.stopPropagation()}
                              />
                            ),
                          }}
                        />
                      </span>
                    </Checkbox>
                  </div>
                </Col>
              )}
              {user &&
                user.company &&
                user.company.enable_external_dsp_selector ? (
                <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={12}
                  xl={12}
                  className="order-dsp"
                  style={{ zIndex: "0" }}
                >
                  <span
                    hidden={
                      this.props.programmatic === "traditional" && !isSuperUser
                    }
                  >
                    <CSSEffect>
                      <CSSTransition
                        in={showBudget}
                        timeout={1000}
                        classNames="my-node"
                      >
                        <Form.Item style={{ marginBottom: "15px" }}>
                          <div
                            disabled={this.props.editCampaignActive}
                            className="custom-container"
                            style={{
                              width:
                                this.state.type === "aiPlanner"
                                  ? "100%"
                                  : "97%",
                            }}
                          >
                            <div className="addon-before-content">
                              <Tooltip
                                placement="right"
                                title={<span>{t("info_dsp")}</span>}
                              >
                                DSP
                                <Icon
                                  type="info-circle"
                                  style={{
                                    marginLeft: "3px",
                                    color:
                                      !dsp || (dsp && dsp.id == null)
                                        ? "#aaaaaad1"
                                        : Colors.atention,
                                  }}
                                  theme="filled"
                                />
                              </Tooltip>
                            </div>
                            <Select
                              data-testid="dsp-select"
                              labelInValue
                              style={{ flex: 1, width: "80%" }}
                              value={{
                                key: dsp && dsp.id ? parseInt(dsp.id) : null,
                              }}
                              loading={this.props.loadingClients}
                              onChange={this.changeDsp.bind(this)}
                              showSearch
                              filterOption={(input, option) =>
                                option.props.children &&
                                option.props.children[0]
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              dropdownStyle={{ width: "300px" }}
                              dropdownMatchSelectWidth={true}
                              disabled={isProgrammaticProviders}
                            >
                              {this.renderIdentificationDsp()}
                            </Select>
                          </div>
                        </Form.Item>
                      </CSSTransition>
                    </CSSEffect>
                  </span>
                </Col>
              ) : null}
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                className="url"
                hidden={this.state.type === "classic"}
              >
                <div
                  style={{ width: "calc(100% - 15px)", marginRight: "15px" }}
                >
                  <Input
                    value={this.state.url}
                    onChange={(e) => this.setState({ url: e.target.value })}
                    placeholder="URL: https://..."
                    style={{
                      borderRadius: "25px",
                      padding: "0px 0px 0px 23px",
                      height: "42px",
                    }}
                  />
                </div>
                {isMediaOwner && (
                  <div style={{ display: "flex", alignItems: "center", marginRight: "15px", whiteSpace: "nowrap" }}>
                    <span style={{ marginRight: "8px", fontSize: "13px", color: domain === 'latinad' ? Colors.snow : Colors.coal }}>
                      {this.props.showAllDisplays ? t("All screens") : t("Only my own screens")}
                    </span>
                    <Switch
                      size="small"
                      checked={this.props.showAllDisplays}
                      onChange={(checked) => this.props.setShowAllDisplays(checked)}
                    />
                  </div>
                )}
                <div style={{ display: "flex", justifyContent: "end" }}>
                  <Button
                    type="primary"
                    className="skipButton"
                    style={{
                      alignItems: "center",
                      justifyContent: "center",
                      display: "flex",
                      minWidth: "45px",
                    }}
                    disabled={isProgrammaticProviders}
                    loading={this.props.loadingPlannerSkip}
                    onClick={() => {
                      if (isGuaranteed && !this.state.acceptedGuaranteedTerms) {
                        return message.error(t("You must accept the terms and conditions for a guaranteed campaign."));
                      }
                      if (
                        (isAgency &&
                          this.props.client &&
                          this.props.brand.id) ||
                        !isAgency
                      ) {
                        if (!this.state.url) {
                          return message.error(t("Enter brand URL to continue"), 10);
                        }
                        const plannerData = {
                          brand_url: this.changeUrl(this.state.url),
                          client_id: this.props.client.id,
                          brand_id: this.props.brand.id,
                        };
                        this.props.clearPlanner();
                        this.handleCreatePlanner(plannerData, true);
                      } else {
                        message.error(t("Select a customer and brand to continue"), 10);
                      }
                    }}
                  >
                    {!this.props.loadingPlannerSkip ? <>{t("Skip")}</> : ""}
                  </Button>
                  <Button
                    className="searchAIPlannerButton"
                    type="primary"
                    style={domain === 'movImagen'
                      ? { background: Colors.snow, borderColor: Colors.primary, color: Colors.primary }
                      : { background: Colors.blueDark, borderColor: Colors.blueDark, color: Colors.white }}
                    disabled={isProgrammaticProviders}
                    loading={this.props.loadingPlanner}
                    onClick={() => {
                      if (isGuaranteed && !this.state.acceptedGuaranteedTerms) {
                        return message.error(t("You must accept the terms and conditions for a guaranteed campaign."));
                      }
                      if (
                        this.props.client &&
                        this.props.brand.id &&
                        this.state.brief &&
                        this.state.url
                      ) {
                        this.props.removeDisplaysCart();
                        this.props.resetFilters();
                        const plannerData = {
                          brief: this.state.brief,
                          brand_url: this.changeUrl(this.state.url),
                          client_id: this.props.client.id,
                          brand_id: this.props.brand.id,
                          dsp_id: this.props.dsp.id ? this.props.dsp.id : null,
                        };
                        this.handleCreatePlanner(plannerData, false);
                      } else if (!this.state.brief) {
                        message.error(t("Enter brief to continue"), 10);
                      } else if (!this.state.url) {
                        message.error(t("Enter brand URL to continue"), 10);
                      } else {
                        message.error(t("Select a customer and brand to continue"), 10);
                      }
                    }}
                  >
                    {!this.props.loadingPlanner ? <>{t("StartSearch")}</> : ""}
                  </Button>
                </div>
              </Col>
              <div
                style={{
                  display: "flex",
                  width: "50%",
                  gap: "15px",
                  paddingLeft: this.props.user ? 0 : "15px",
                }}
              >
                <Col
                  xs={23}
                  sm={23}
                  md={16}
                  lg={16}
                  xl={16}
                  // className={this.props.user !== null ? "order-budget" : "order-budget-no-user"}
                  style={{ zIndex: "0" }}
                >
                  <span
                    hidden={
                      this.props.programmatic === "traditional" ||
                      this.state.type === "aiPlanner"
                    }
                  >
                    <CSSEffect>
                      <CSSTransition
                        in={showBudget}
                        timeout={1000}
                        classNames="my-node"
                      >
                        <Form.Item>
                          <Input
                            addonBefore={<div>{this.props.currency} $</div>}
                            type="number"
                            min={getMinimunByCurrency(this.props.currency)}
                            max={999999999999.99}
                            autoComplete="budgetInput"
                            placeholder={t("Budget")}
                            className="budgetInput"
                            value={
                              this.props.amountBudget
                                ? this.props.amountBudget
                                : ""
                            }
                            onChange={this.handleAmountChange.bind(this)}
                          />
                        </Form.Item>
                      </CSSTransition>
                    </CSSEffect>
                  </span>
                </Col>
                <Col
                  xs={23}
                  sm={23}
                  md={7}
                  lg={7}
                  xl={7}
                  className="search-button-col"
                  hidden={this.state.type === "aiPlanner"}
                  style={{ marginLeft: "auto", zIndex: "0" }}
                >
                  <Button
                    className={domain === "dv360" ? "searchButton" : "searchAIPlannerButton"}
                    type="primary"
                    style={domain === 'movImagen'
                      ? { width: "100%", margin: "0", background: Colors.snow, borderColor: Colors.primary, color: Colors.primary }
                      : { width: "100%", margin: "0", background: Colors.blueDark, borderColor: Colors.blueDark, color: Colors.white }}
                    disabled={isProgrammaticProviders}
                    onClick={() => {
                      if (isGuaranteed && !this.state.acceptedGuaranteedTerms) {
                        return message.error(t("You must accept the terms and conditions for a guaranteed campaign."));
                      }
                      if (
                        (isAgency &&
                          this.props.client &&
                          this.props.brand.id) ||
                        !isAgency
                      ) {
                        const doNavigate = () => {
                          this.props.removeDisplaysCart();
                          this.props.resetFilters();
                          this.props.clearCampaignData("searchBox");
                          this.props.history.push(
                            "/map?" +
                            queryString.stringify(
                              updateParams(
                                {},
                                {
                                  ...getDatesRange(
                                    this.state.startDate,
                                    this.state.endDate
                                  ),
                                  lat_sw: this.state.bounds
                                    ? this.state.bounds.lat_sw
                                    : this.state.lat_sw,
                                  lng_sw: this.state.bounds
                                    ? this.state.bounds.lng_sw
                                    : this.state.lng_sw,
                                  lat_ne: this.state.bounds
                                    ? this.state.bounds.lat_ne
                                    : this.state.lat_ne,
                                  lng_ne: this.state.bounds
                                    ? this.state.bounds.lng_ne
                                    : this.state.lng_ne,
                                  programmatic: programmatic === 'programmatic' ? 'true' : 'false',
                                  is_guaranteed: isGuaranteed ? '1' : '0',
                                },
                                { arrayFormat: "bracket" }
                              )
                            )
                          );
                        };
                        if (this.isUnverifiedMediaCompany()) {
                          this._pendingNavigation = doNavigate;
                          this.setState({ isMediaCompanyInfoModalVisible: true });
                        } else {
                          doNavigate();
                        }
                      } else {
                        message.error(
                          t("Select a customer and brand to continue"),
                          10
                        );
                      }
                    }}
                  >
                    {t("StartSearch")}
                  </Button>
                </Col>
              </div>
            </Row>
          </Col>
        </Row>
        <VerifiedAgencyInfoModal
          isVisible={this.state.isVerifiedAgencyModalVisible}
          hide={this.hideVerifiedAgencyModal}
          message={this.state.verifiedAgencyError}
        ></VerifiedAgencyInfoModal>
        <VerifiedAgencyInfoModal
          isVisible={this.state.isMediaCompanyInfoModalVisible}
          hide={() => this.setState({ isMediaCompanyInfoModalVisible: false })}
          message={t('Unverified media company info')}
          onContinue={() => {
            if (this._pendingNavigation) this._pendingNavigation();
            this._pendingNavigation = null;
          }}
        ></VerifiedAgencyInfoModal>
        <CampaignFormModal
          visible={!!this.props.showCampaignFormModal && this.state.didMount}
          onCancel={() => {
            this.props.toggleCampaignFormModal(false);
            this.props.clearPlanner();
          }}
        />
        <Modal
          className="ia-brief-modal"
          visible={this.state.optimizeBriefModalVisible}
          onCancel={() => {
            this.setState({ optimizeBriefModalVisible: false });
            this.props.clearOptimizedBrief();
          }}
          footer={null}
          title={null}
          closable={false}
          width={460}
          bodyStyle={{ background: "#303030", padding: 0, borderRadius: "10px", overflow: "hidden" }}
          style={{ borderRadius: "10px", overflow: "hidden" }}
        >
          {this.props.optimizedBrief && (
            <BriefModalWrapper>
              <BriefModalHeader>
                <BriefModalTitle>
                  <img src={logoAI} style={{ maxHeight: "20px" }} alt="" />
                  {t("IA Brief")}
                </BriefModalTitle>
                <BriefModalClose onClick={() => {
                  this.setState({ optimizeBriefModalVisible: false });
                  this.props.clearOptimizedBrief();
                }}>
                  <Icon type="close" />
                </BriefModalClose>
              </BriefModalHeader>
              <BriefModalBody>
                <BriefModalCard>
                  <BriefModalCardLabel>{t("Justification")}:</BriefModalCardLabel>
                  <BriefModalCardContent>{this.props.optimizedBrief.justification}</BriefModalCardContent>
                </BriefModalCard>
                <BriefModalCard>
                  <BriefModalCardLabel>{t("New brief")}:</BriefModalCardLabel>
                  <BriefModalCardContent>{this.props.optimizedBrief.ai_optimized_brief}</BriefModalCardContent>
                </BriefModalCard>
                <BriefModalFooter>
                  <BriefModalBackBtn onClick={() => {
                    this.setState({ optimizeBriefModalVisible: false });
                    this.props.clearOptimizedBrief();
                  }}>
                    {t("Go back")}
                  </BriefModalBackBtn>
                  <BriefModalConfirmBtn type="primary" onClick={() => {
                    this.setState({
                      brief: this.props.optimizedBrief.ai_optimized_brief,
                      optimizeBriefModalVisible: false,
                    });
                    this.props.clearOptimizedBrief();
                  }}>
                    {t("Continue with this brief")}
                  </BriefModalConfirmBtn>
                </BriefModalFooter>
              </BriefModalBody>
            </BriefModalWrapper>
          )}
        </Modal>
      </SearchBoxHolder>
    );
  }
}

const Extended = withTranslation()(SearchBoxContainer);
Extended.static = SearchBoxContainer.static;

export default withRouter(Extended);